import { render } from "./ImagePolypsComponents.vue?vue&type=template&id=c303be4a"
import script from "./ImagePolypsComponents.vue?vue&type=script&lang=js"
export * from "./ImagePolypsComponents.vue?vue&type=script&lang=js"

import "./ImagePolypsComponents.vue?vue&type=style&index=0&id=c303be4a&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__